import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';
import { GetOfflineCheckListQueryResponseType } from '@/modules/OfflineFiles/queries/getOfflineCheckList/getOfflineCheckListQuery.type';

export const getOfflineCheckListFunction = (): Promise<
  PaginationResponseType<GetOfflineCheckListQueryResponseType[]>
> => {
  return fetchApi.get('offline_shooting/check-list/');
};
